import { Form, Input, InputNumber } from "antd";
import { NamePath } from "antd/es/form/interface";
import * as React from "react";
import { ZodNumber, ZodString } from "zod";
import { $ZodType } from "zod/v4/core";

import { AttrFeatures } from "../AttrFeatures";
import { FieldDef, itemName, makeLabel } from "./attrMetaEditorUtils";
import { AttrMetaColSpan } from "./components/AttrMetaColSpan";
import { AttrMetaViewWidth } from "./components/AttrMetaViewWidth";
import { MetaSelectCatalogId } from "./components/MetaSelectCatalogId";
import { MetaSelectValueCatalogId } from "./components/MetaSelectValueCatalogId";
import { SelectEditComponent } from "./components/SelectEditComponent";
import { SelectTopType } from "./components/SelectTopType";
import { SelectViewComponent } from "./components/SelectViewComponent";

/* eslint react/prop-types: "off" */

type CtrlCustom = {
  test: RegExp;
  Comp?: React.FC<{
    node: $ZodType;
    path: string[];
    field?: FieldDef;
  }>;
  Select?: React.FC<{
    path: NamePath;
    value?: string;
    onChange?(value?: string): void;
    attrFeatures: AttrFeatures;
  }>;
  tooltip?: string;
};

const customs: CtrlCustom[] = [
  {
    test: /(^uid)|(type\.fields\.\d+\.uid)$/,
    Comp: ({ node, path }) => (
      <Form.Item
        name={itemName(path)}
        label={node instanceof ZodString ? makeLabel(node, path) : "UID"}
      >
        <Input disabled />
      </Form.Item>
    ),
  },
  {
    test: /(^displayId)|(type\.fields\.\d+\.displayId)$/,
    Comp: ({ node, path }) => (
      <Form.Item
        name={itemName(path)}
        label={node instanceof ZodNumber ? makeLabel(node, path) : "Display Id"}
      >
        <InputNumber disabled />
      </Form.Item>
    ),
  },
  {
    test: /(^|\.)view\.width$/,
    Comp: AttrMetaViewWidth,
  },
  {
    test: /(^|\.)edit\.colSpan$/,
    Comp: AttrMetaColSpan,
  },
  {
    test: /edit\.component$/,
    Select: SelectEditComponent,
  },
  {
    test: /view\.component$/,
    Select: SelectViewComponent,
  },
  {
    test: /^type$/,
    Select: SelectTopType,
  },
  {
    test: /edit\.component\.catalogId$/,
    Comp: MetaSelectCatalogId,
  },
  {
    test: /edit\.component\.(options\.)?valuesCatalogId$/,
    Comp: MetaSelectValueCatalogId,
  },
];

export const findCustom = (path: string[]): CtrlCustom | undefined => {
  const strPath = path.join(".");
  return customs.find(({ test }) => test.test(strPath));
};
